<template>
    <div ref="interactive" class="interactive"  :class="[{ focus, jump, disabled }, jumpSize]" @click="emitClick">
        <!-- <div class="slot-holder"> -->
            <slot></slot>
        <!-- </div> -->
    </div>
</template>

<script>
export default {
    name: 'interactive',
    props: {
        jumpSize: {
            type: String,
            default: 'small'
        }
    },
    data() {
        return {
            focus: false,
            jump: false,
            lastFocusedTimestamp: null,
            disabled: false,
        }
    },
    methods: {
        async handleClick() {
            return
            if(!this.focus) return
            await new Promise(r => setTimeout(r, 100));
            if("vibrate" in navigator) {
                try {
                    navigator.vibrate = navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate || navigator.msVibrate;                        
                    if (navigator.vibrate) { 
                        navigator.vibrate(100);
                    }
                } catch(error) {}
            }
        },
        emitClick(event) {
            this.$emit('click', event);
        },
        handleFocus() {
            this.lastFocusedTimestamp = Date.now();
            this.focus = true;
            this.jump = false;
        },
        async handleUnfocus(targetElement) {
            if (!this.focus) return

            const button = this.$refs.interactive;
            if (!button.contains(targetElement)) return this.focus = false;
            
            this.jump = true;
            const milisecondsToWait = this.lastFocusedTimestamp + 100 - Date.now();
            if(milisecondsToWait > 0) await new Promise(r => setTimeout(r, milisecondsToWait));
            this.focus = false;
            await new Promise(r => setTimeout(r, 250));
            this.jump = false;
        },
        handleTargetElement(event) {
            console.log('target')
            const target = event.target;
            const button = this.$refs.interactive;
            if(button.contains(target)) this.handleFocus();
        },
        async handleTargetElementMoved(event) {
            if(!this.focus) return
            const button = this.$refs.interactive;
            if(!button.contains(event.target) && button !== event.target) return
            console.log(button.contains(event.target), button !== event.target)
            
            this.jump = false;
            this.focus = false;
        },
        async handleClickElement(targetElement) {
            const button = this.$refs.interactive;
            if(button.contains(targetElement) || button === targetElement) this.handleClick();
            this.handleUnfocus(targetElement);
        }
    },
    mounted() {
        const vm = this;
        this.$root.$on('targetElement', vm.handleTargetElement);
        this.$root.$on('targetElementMoved', vm.handleTargetElementMoved);
        this.$root.$on('clickElement', vm.handleClickElement);
    },
    beforeDestroy() {
        const vm = this;
        this.$root.$off('targetElement', vm.handleTargetElement);
        this.$root.$off('targetElementMoved', vm.handleTargetElementMoved);
        this.$root.$off('clickElement', vm.handleClickElement);
    }
}
</script>

<style lang="scss" scoped>
.interactive {
    --timing-function: cubic-bezier(.51,4,.45,1.08);
    --scale-to: 0.9;
    // animation: reset 200ms ease;
    
    &.small {
        --timing-function: cubic-bezier(.51,2,.45,1.08);
        --scale-to: 0.95;
    }
    &.big {
        --timing-function: cubic-bezier(.51,4,.45,1.08);
        --scale-to: 0.9;
    }
    
    &.jump {
        animation: jump 250ms var(--timing-function);
    }

    &.focus {
        animation: focus 200ms ease forwards;
    }
}

@keyframes reset {
    to {
        scale: 1;
    }
}

@keyframes focus {
    from {
        scale: 1;
    } to {
        scale: var(--scale-to);
    }
}

@keyframes jump {
    from {
        scale: var(--scale-to);
    } to {
        scale: 1;
    }
}
</style>

